export const SCENARIO_HYDRATE_RECEIVED = 'SCENARIO_HYDRATE_RECEIVED';
